import { parseRuntime } from './impl-helper';
// eslint-disable-next-line max-len
const { plugins: { weblib } } = require('@futuweb/fego-render');
const { nn } = weblib['@futuweb/tool-nn'];
const { laterThanIOS, laterThanAndroid, laterThanMac, laterThanPC, beforeThanIOS, beforeThanAndroid, beforeThanMac, beforeThanPC } = nn;


function checkVersion(clientType, minVersion, maxVersion) {
    if (!minVersion) {
        minVersion = '0.0.0';
    }
    if (!maxVersion) {
        maxVersion = '999.999.999';
    }
    const checkMap = {
        pc: {
            laterThan: laterThanPC,
            beforeThan: beforeThanPC
        },
        mac: {
            laterThan: laterThanMac,
            beforeThan: beforeThanMac
        },
        ios: {
            laterThan: laterThanIOS,
            beforeThan: beforeThanIOS
        },
        android: {
            laterThan: laterThanAndroid,
            beforeThan: beforeThanAndroid
        }
    };
    const check = checkMap[clientType.toLowerCase()];

    if (!check) {
        return false;
    }

    return check.laterThan(minVersion) && check.beforeThan(maxVersion);
}

export const getClientVerFactRender = async (params, almanac) => {
    // eslint-disable-next-line no-unused-vars
    const { runtime, variable, current } = await parseRuntime(params, almanac);
    //处理默认的变量
    console.log(`=========[fego-condition][client-ver-fact]`, variable, current);
    if (current.port.id === 'default') {
        //取出除了default之外的所有port
        const others = current?.node?.data?.factInfo?.outs?.filter((port) => port.id !== 'default') || [];
        //如果其它的port都不满足条件，那么就代表命中了default条件。那么就返回true
        const isAllFalse = others.every((port) => {
            const { clientType, minVersion, maxVersion } = port;
            const res = checkVersion(clientType, minVersion, maxVersion);
            return !res;
        });

        if (isAllFalse) {
            return true;
        }

        return false;
    }

    const { clientType, minVersion, maxVersion } = current.port;
    const res = checkVersion(clientType, minVersion, maxVersion);
    return res;
};
